import { Box, Text } from '@chakra-ui/react';

export interface DateBadgeProps {
  /**
   * Date to render. Accepts a Date or a string. Strings must be either
   * a YYYY-MM-DD (calendar-day) or a full ISO 8601 timestamp
   * (e.g. "2026-10-05T19:00:00Z"). YYYY-MM-DD inputs are interpreted in the
   * local timezone so they always show the intended calendar day.
   */
  date: Date | string;
}

/** Compact 48×48 calendar badge showing abbreviated month and day number. */
export const DateBadge = ({ date }: DateBadgeProps) => {
  const d =
    typeof date === 'string' ? new Date(date.includes('T') ? date : `${date}T00:00:00`) : date;
  const month = d.toLocaleString('en-US', { month: 'short' });
  const day = String(d.getDate()).padStart(2, '0');

  return (
    <Box
      borderRadius="md"
      border="1px solid"
      borderColor="stroke.divider.default"
      overflow="hidden"
      flexShrink={0}
      boxSize="48px"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Box
        bg="stroke.divider.default"
        width="100%"
        h="21px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Text variant="SmallBodyRegular" color="text.primary" whiteSpace="nowrap">
          {month}
        </Text>
      </Box>
      <Box flex="1" display="flex" alignItems="center" justifyContent="center" width="100%">
        <Text variant="MainBodyMedium" color="text.primary" whiteSpace="nowrap">
          {day}
        </Text>
      </Box>
    </Box>
  );
};
